import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { array } from "../../../shared/src/codecs/types/array";
import { boolean } from "../../../shared/src/codecs/types/boolean";
import { formIO } from "../../../shared/src/codecs/types/formIO";
import { integer } from "../../../shared/src/codecs/types/integer";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { required } from "../../../shared/src/codecs/types/required";
import { string } from "../../../shared/src/codecs/types/string";
import { union } from "../../../shared/src/codecs/types/union";
import { ListingId } from "../ListingId";

export const ListingPnlLine = required({
    description: string(),
    forecast_net_pence: union([integer(), nullCodec()]),
    actual_net_pence: union([integer(), nullCodec()]),
    is_actual: boolean(),
});
export type TListingPnlLineCodec = typeof ListingPnlLine;
export type TListingPnlLine = TTypeOfCodec<TListingPnlLineCodec>;

// A re-billed service, shown gross as two lines (income = what the client pays,
// cost = what the supplier charges us) with the per-job margin between them. The
// two lines reconcile against the two real Xero invoices (ACCREC to client, ACCPAY
// to supplier); the margin is the spread Sail keeps.
export const ListingPnlServiceGroup = required({
    service_type: string(),
    income: ListingPnlLine,
    cost: ListingPnlLine,
    margin_forecast_net_pence: union([integer(), nullCodec()]),
    margin_actual_net_pence: union([integer(), nullCodec()]),
});
export type TListingPnlServiceGroupCodec = typeof ListingPnlServiceGroup;
export type TListingPnlServiceGroup = TTypeOfCodec<TListingPnlServiceGroupCodec>;

// The computed statement. `ea_fee` is null on a no-estate-agency listing. `other_*`
// hold orphan actuals — invoices billed against the listing that match no modelled
// line ("billed but unmodelled"). The three totals let the UI show pure Forecast,
// pure Actual, and the headline Blended net (actual per line where it exists, else
// forecast). All net of VAT.
export const ListingPnlOutput = required({
    ea_fee: union([ListingPnlLine, nullCodec()]),
    service_groups: array(ListingPnlServiceGroup),
    other_income: array(ListingPnlLine),
    other_cost: array(ListingPnlLine),
    total_forecast_net_pence: integer(),
    total_actual_net_pence: integer(),
    total_blended_net_pence: integer(),
});
export type TListingPnlOutputCodec = typeof ListingPnlOutput;
export type TListingPnlOutput = TTypeOfCodec<TListingPnlOutputCodec>;

export const ListingPnlFormIO = formIO(ListingId, ListingPnlOutput);
export type TListingPnlFormIOCodec = typeof ListingPnlFormIO;
export type TListingPnlFormIO = TTypeOfCodec<TListingPnlFormIOCodec>;
